let instance = null;
const locks = new Set();
let savedOverflow = null;

export const prefersReducedMotion = () =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;

// One owner for wheel inertia, anchor navigation and modal scroll locking.
export function initializeSmoothScroll(Lenis) {
  const lenis = new Lenis({
    duration: 1.2,
    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    smoothWheel: true,
    autoRaf: true,
    stopInertiaOnNavigate: true,
  });
  instance = lenis;
  const syncVisibility = () => {
    if (document.hidden || locks.size) lenis.stop();
    else lenis.start();
  };
  syncVisibility();
  document.addEventListener('visibilitychange', syncVisibility);
  return () => {
    document.removeEventListener('visibilitychange', syncVisibility);
    if (instance === lenis) instance = null;
    // Lenis owns and cancels its autoRaf loop, including StrictMode remounts.
    lenis.destroy();
  };
}

export function scrollTo(target, { immediate = false, offset = 0 } = {}) {
  if (target == null || locks.size) return false;
  const instant = immediate || prefersReducedMotion();
  if (instance) {
    // Cancel the previous wheel tween even when the new target is already current.
    instance.reset();
    instance.resize();
    instance.scrollTo(target, { immediate: instant, offset });
  } else {
    const top = typeof target === 'number'
      ? target
      : target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top + offset, behavior: instant ? 'instant' : 'smooth' });
  }
  return true;
}

export const scrollToSection = id => scrollTo(document.getElementById(id));

export function lockPageScroll() {
  const token = Symbol('scroll-lock');
  if (!locks.size) {
    savedOverflow = {
      html: document.documentElement.style.overflow,
      body: document.body.style.overflow,
    };
    instance?.stop();
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  locks.add(token);
  let released = false;
  return () => {
    if (released) return;
    released = true;
    locks.delete(token);
    if (!locks.size) {
      document.documentElement.style.overflow = savedOverflow.html;
      document.body.style.overflow = savedOverflow.body;
      savedOverflow = null;
      if (!document.hidden) instance?.start();
    }
  };
}
